import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { api, formatErrorDetail } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";
import { toast } from "sonner";
import { Mail, Check, Loader2 } from "lucide-react";

export default function NewsletterForm({ source = "landing" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setDone(true);
      trackEvent("Subscribe", { email_provided: true });
      toast.success("Inscription confirmée !", { description: "Surveillez votre boîte mail." });
    } catch (err) {
      toast.error(formatErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="flex items-center gap-3 rounded-full bg-[#25D366]/15 border border-[#25D366]/40 px-5 py-3" data-testid="newsletter-success">
        <span className="h-7 w-7 rounded-full bg-[#25D366] text-white grid place-items-center">
          <Check className="h-4 w-4" strokeWidth={3} />
        </span>
        <p className="text-sm text-[#2C2420]">Inscription confirmée — à très vite.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md w-full" data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[#6B5D54]" />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Votre email"
          className="w-full h-12 pl-11 pr-4 rounded-full bg-white/95 border border-white/40 focus:border-[#C58C85] focus:outline-none text-sm text-[#2C2420] placeholder:text-[#6B5D54]/60 backdrop-blur"
          data-testid="newsletter-email-input"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="rounded-full bg-[#C58C85] hover:bg-[#A6726B] text-white h-12 px-6"
        data-testid="newsletter-submit-btn"
      >
        {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Inscription…</> : "Je m'inscris"}
      </Button>
    </form>
  );
}
